import React, { useState } from "react";
import { Expand } from "lucide-react";
import { useLang } from "../LanguageContext";
import Lightbox from "./Lightbox";

const IMAGES = [
  {
    src: "/photos/gallery-sala-tavoli.jpg",
    alt: "La nostra sala",
    span: "md:col-span-7 md:row-span-2",
    ratio: "aspect-[4/5] md:aspect-auto md:h-full",
  },
  {
    src: "/photos/gallery-tartare-fassona.jpg",
    alt: "Battuta di Fassona Piemontese con pistacchi",
    span: "md:col-span-5",
    ratio: "aspect-[4/3]",
  },
  {
    src: "/photos/gallery-tajarin-ragu.jpg",
    alt: "Tajarin al ragù di salsiccia",
    span: "md:col-span-5",
    ratio: "aspect-[4/3]",
  },
  {
    src: "/photos/gallery-sala-affresco.jpg",
    alt: "Sala da pranzo con affresco delle Langhe",
    span: "md:col-span-12",
    ratio: "aspect-[21/9]",
  },
  {
    src: "/photos/gallery-vitello-tonnato.jpg",
    alt: "Vitello tonnato",
    span: "md:col-span-4",
    ratio: "aspect-square",
  },
  {
    src: "/photos/gallery-agnolotti.jpg",
    alt: "Ravioli del «Plin»",
    span: "md:col-span-4",
    ratio: "aspect-square",
  },
  {
    src: "/photos/gallery-bonet.jpg",
    alt: "I nostri dolci",
    span: "md:col-span-4",
    ratio: "aspect-square",
  },
  {
    src: "/photos/gallery-botti-scale.jpg",
    alt: "Botti e scale della cantina",
    span: "md:col-span-4",
    ratio: "aspect-square",
  },
  {
    src: "/photos/hero-cantina.jpg",
    alt: "Il tavolo in cantina",
    span: "md:col-span-4",
    ratio: "aspect-square",
  },
  {
    src: "/photos/gallery-bottiglie.jpg",
    alt: "Le nostre bottiglie",
    span: "md:col-span-4",
    ratio: "aspect-square",
  },
];

export default function Galleria() {
  const { t } = useLang();
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section
      id="galleria"
      data-testid="galleria-section"
      className="bg-[#EBE7DD] py-24 md:py-40 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-6 reveal-on-scroll">
            <p className="text-[11px] uppercase tracking-[0.35em] text-[#565F41] mb-6">
              {t.galleria.eyebrow}
            </p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[0.95] tracking-tight whitespace-pre-line text-[#23211E]">
              {t.galleria.title}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 flex items-end reveal-on-scroll">
            <p className="text-base md:text-lg font-light leading-relaxed text-[#3D3A35]">
              {t.galleria.intro}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[minmax(180px,auto)] gap-4 md:gap-6">
          {IMAGES.map((img, i) => (
            <button
              key={i}
              type="button"
              data-testid={`gallery-item-${i}`}
              onClick={() => setActiveIndex(i)}
              className={`overflow-hidden group relative cursor-zoom-in ${img.span} ${img.ratio} reveal-on-scroll`}
              style={{ transitionDelay: `${(i % 4) * 80}ms` }}
              aria-label={`Open ${img.alt} fullscreen`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-[#23211E]/10" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500 flex items-center justify-center">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[#F5F2EC]/90 text-[#23211E] p-3 rounded-full">
                  <Expand className="w-5 h-5" strokeWidth={1.4} />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Lightbox
        images={IMAGES}
        index={activeIndex}
        onClose={() => setActiveIndex(null)}
        onNavigate={(newIdx) => setActiveIndex(newIdx)}
      />
    </section>
  );
}
